/* tslint:disable */

export enum WorkflowActionCommentValidationModeEnum {
  Optional = 0,
  Required = 1,
  Disabled = 2,
}
